import API from "../../common/API";
import { API_URL } from "../../config/config";

/*** 
@purpose : Get parent child facility listing
@Parameter : {body}
**/
export const getParentChildFacility = async (body) => {
  const token = sessionStorage.getItem("token");
  const role = sessionStorage.getItem("User role");
  const wwid = sessionStorage.getItem("WWID");
  let timestamp = new Date().getTime();
  return fetch(API_URL + API.GET_PARENT_CHILD_FACILITY, {
    method: "post",
    headers: {
      "x-api-key": token,
      "Access-Control-Allow-Origin": "*",
      timestamp: timestamp,
      mode: "no-cors",
      wwid: wwid,
      role: role,
    },
    body: JSON.stringify(body),
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (data) {
      return data;
    });
};

/*** 
@purpose : Add comments
@Parameter : {body}
**/
export const addComments = async (body) => {
  const token = sessionStorage.getItem("token");
  let timestamp = new Date().getTime();
  const wwid = sessionStorage.getItem("WWID");
  return fetch(API_URL + API.APPROVE_REJECT, {
    method: "post",
    headers: {
      "x-api-key": token,
      wwid: wwid,
      "Access-Control-Allow-Origin": "*",
      timestamp: timestamp,
      mode: "no-cors",
    },
    body: JSON.stringify(body),
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (data) {
      return data;
    });
};
